import { Routes } from '@angular/router';
import { AuthGuard } from './shared/gurads/auth.guard';
import { clusterPricingGuard } from './core/guards/cluster-pricing.guard';
import { adminSettingsGuard } from './core/guards/admin-settings.guard';
import { strategyPriceOverrideGuard } from './core/guards/strategy-price-override.guard';
import { featureRoutes } from './configuration/feature-routes';

export const routes: Routes = [
  { path: '', redirectTo: '/pages', pathMatch: 'full' },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadComponent: () => import('./core/layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      //      {
      //        path: 'fx-rate',
      //        canActivate: [fxRateGuard],
      //      },
      {
        path: 'autopilot-configuration',
        canActivate: [clusterPricingGuard],
        loadComponent: () =>
          import('./core/pages/cluster-pricing/pricing-configuration/pricing-configuration.component').then(
            (m) => m.PricingConfigurationComponent,
          ),
      },
      {
        path: 'super-admin-settings',
        canActivate: [adminSettingsGuard],
        loadComponent: () =>
          import('./core/pages/admin-settings/admin-settings-container/admin-settings-container.component').then(
            (m) => m.AdminSettingsContainerComponent,
          ),
      },
      {
        path: 'bulk-change',
        canActivate: [strategyPriceOverrideGuard],
        loadComponent: () =>
          import(
            './core/pages/strategy-price-override/strategy-price-override-page/strategy-price-override-page.component'
          ).then((m) => m.strategyPriceOverridePageComponent),
      },
      {
        path: 'page-not-found',
        loadComponent: () =>
          import('./core/layout/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
      },
      ...featureRoutes,
    ],
  },
  { path: '**', redirectTo: '/pages/page-not-found' },
];
